// TimerStore – Mock-Daten (werden später durch Backend ersetzt)

export const IMAGES = {
  heroPrinter: "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHwzRCUyMHByaW50ZXJ8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  printerColor: "https://images.unsplash.com/photo-1705475025559-ad8efdedc74f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHwzRCUyMHByaW50ZXJ8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  printerClose: "https://images.unsplash.com/photo-1611117775350-ac3950990985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHwzRCUyMHByaW50ZXJ8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  cosplayArmor: "https://images.unsplash.com/photo-1715849694154-42dc79cf73cc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxjb3NwbGF5JTIwYXJtb3J8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  cosplaySword: "https://images.unsplash.com/flagged/photo-1569517282304-d1e2baf737e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxjb3NwbGF5JTIwYXJtb3J8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  animeFigures: "https://images.unsplash.com/photo-1621478374422-35206faeddfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxhbmltZSUyMGZpZ3VyZXN8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  figureShelf: "https://images.unsplash.com/photo-1714537097791-be0ba0473b9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxhbmltZSUyMGZpZ3VyZXN8ZW58MHx8fHwxNzkwNzgwNzg0fDA&ixlib=rb-4.1.0&q=85&w=1200",
  dragon: "https://images.unsplash.com/photo-1610926597998-fc7f2c1b89b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxkcmFnb24lMjBtb2RlbHxlbnwwfHx8fDE3OTA3ODA3ODl8MA&ixlib=rb-4.1.0&q=85&w=900",
};

export const products = [
  {
    id: "p1",
    name: "Samurai Helm",
    variant: "Crimson",
    price: 129.9,
    badge: "Neu",
    category: "Cosplay",
    inStock: true,
    description:
      "Detailreicher Samurai Helm im japanischen Stil. Perfekt für dein nächstes Cosplay oder als Deko.",
    image: "https://images.unsplash.com/photo-1615790469537-7c9d8e95c047?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p2",
    name: "Drachenfigur",
    variant: "Frostwing",
    price: 79.9,
    badge: "Sofort lieferbar",
    category: "Figuren",
    inStock: true,
    description:
      "Hochwertig gedruckte Drachenfigur mit beeindruckenden Details und stabiler Verarbeitung.",
    image: IMAGES.dragon,
  },
  {
    id: "p3",
    name: "Kitsune Maske",
    variant: "Sakura",
    price: 39.9,
    badge: "Sofort lieferbar",
    category: "Cosplay",
    inStock: true,
    description:
      "Handgefertigter 3D-Druck mit aufwendigen Details. Ideal für Cosplay oder als Wanddekoration.",
    image: "https://images.unsplash.com/photo-1781093842373-b973b4653ab2?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p4",
    name: "Anime Figur",
    variant: "Naruto",
    price: 89.9,
    badge: "Neu",
    category: "Figuren",
    inStock: true,
    description:
      "Hochwertige Sammelfigur mit feinen Details und stabiler Basis. Ein Highlight für jeden Fan.",
    image: "https://images.unsplash.com/photo-1621478374422-35206faeddfb?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p5",
    name: "Schwertständer",
    variant: "Holzoptik",
    price: 49.9,
    badge: "Sofort lieferbar",
    category: "Zubehör",
    inStock: false,
    description:
      "Stilvoller Schwertständer im japanischen Design. Passend für Katanas und andere Schwerter.",
    image: "https://images.unsplash.com/photo-1671015522549-e7aa41ded44f?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p6",
    name: "Cosplay Accessoire",
    variant: "Armreif",
    price: 29.9,
    badge: "Neu",
    category: "Cosplay",
    inStock: true,
    description:
      "Detailgetreues Accessoire für dein Cosplay. Leicht, robust und perfekt verarbeitet.",
    image: "https://images.unsplash.com/photo-1577892211256-b03ac5f488b8?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p7",
    name: "Würfelturm",
    variant: "Fantasy",
    price: 34.9,
    badge: "Sofort lieferbar",
    category: "Zubehör",
    inStock: true,
    description:
      "Praktischer Würfelturm im Fantasy-Design. Sorgt für faire Würfe und ein cooles Spielerlebnis.",
    image: "https://images.unsplash.com/photo-1772121034582-c7d18ae49e5c?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "p8",
    name: "LED Deko",
    variant: "Eule",
    price: 59.9,
    badge: "Neu",
    category: "Dekoration",
    inStock: false,
    description:
      "Stimmungsvolle LED-Dekoration mit 3D-Effekt. Perfekt für dein Zimmer, Gaming-Setup oder als Geschenk.",
    image: "https://images.unsplash.com/photo-1616258583942-2c094c011737?auto=format&fit=crop&w=800&q=80",
  },
];

export const categories = ["Alle", "Cosplay", "Figuren", "Dekoration", "Zubehör"];

export const formatPrice = (p) =>
  p.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
